import React from "react";
import {Box, Container, Typography} from "@mui/material";
import {colors} from "../../styling/GlobalTheme";

/* Bandeau titre des pages intérieures, avec photo de fond. */
export default function PageHeader({title, subtitle, image}: { title: string; subtitle?: string; image?: string }) {
    return (
        <Box sx={{
            position: "relative", color: "#fff", pt: {xs: 14, md: 18}, pb: {xs: 6, md: 9}, overflow: "hidden",
            bgcolor: colors.night,
        }}>
            {image && <Box sx={{
                position: "absolute", inset: 0, backgroundImage: `url("${image}")`, backgroundSize: "cover",
                backgroundPosition: "center", opacity: .45, animation: "mp-zoom 8s ease-out both",
            }}/>}
            <Box sx={{position: "absolute", inset: 0, background: `linear-gradient(180deg, rgba(11,18,32,.3), ${colors.night})`}}/>
            <Container maxWidth="lg" sx={{position: "relative"}}>
                <Typography variant="h1" sx={{fontSize: {xs: "3.2rem", md: "5rem"}}}>{title}</Typography>
                {subtitle && <Typography sx={{mt: 1, fontSize: {xs: "1rem", md: "1.2rem"}, opacity: .85, maxWidth: 700}}>{subtitle}</Typography>}
                <Box sx={{mt: 3, width: 70, height: 4, bgcolor: colors.glacier, borderRadius: 2}}/>
            </Container>
        </Box>
    );
}
